import { Routes, Route, Navigate } from "react-router-dom";
import Login from '../pages/login';
import Register from '../pages/register';
import Otp from '../pages/otp';
import ForgotPassword from '../pages/forgot-password';
import Home from '../pages/home';
import Deposit from '../pages/deposit';
import Withdrawal from '../pages/withdrawal';
import Layout from '../layout/layout';
import ProtectedLayout from '../layout/protected-layout';
import ProtectedLayoutNoFooter from '../layout/protected-layout-no-footer';
import Gamedetail from "../pages/game-detail";
import MyAccount from "../pages/my-account";
import Upi from "../pages/upi";
import Bank from "../pages/bank";
import Qr from "../pages/qr";
import Tether from "../pages/tether";
import Aed from '../pages/aed';
import Addbank from "../pages/add-bank";
import Success from "../pages/success";
import Transactionhistory from "../pages/transaction-history";
import Completed from "../pages/completed";
import Failed from "../pages/failed";
import TransactionDetail from "../pages/transaction-detail";
import PlayGame from "../pages/play-game";
import MatchList from "../pages/match-list";
import Reciept from "../pages/reciept";
import Mines from "../pages/mines";
import Aviator2 from "../pages/aviator2";
import Aviator from "../pages/aviator";
import Plinko from "../pages/plinko-old";
import PlinkoGame from "../pages/plinko";
// import SeriesList from "../pages/series-list";
import AutoApiCallComponent from "../pages/autoApi";
import DepositPayment from "../pages/depositPayment";

export const AppRouter = () => {   
    return (
        <Routes>
            <Route element={<ProtectedLayout />}>
                {/* <Route path='chart' element={<Chart />} />                 */}
                <Route path='game-detail/:match_id' element={<Gamedetail />} />
                <Route path='play-game/:uuid' element={<PlayGame />} />
                <Route path='mines' element={<Mines />} />
                <Route path='aviator' element={<Aviator />} />
                <Route path='plinko' element={<PlinkoGame />} />
                <Route path='plinko2' element={<Plinko/>} />
                {/* <Route path='aviator2' element={<Aviator />} /> */}
            </Route>
            
            <Route element={<ProtectedLayoutNoFooter />}>
                {/* <Route path='series-list' element={<SeriesList />} /> */}
                <Route path='match-list' element={<MatchList />} />
                <Route path='my-account' element={<MyAccount />} />                 
                <Route path='upi' element={<Upi />} />
                <Route path='bank' element={<Bank />} />
                <Route path='qr' element={<Qr />} />
                <Route path='deposit' element={<Deposit />} />
                <Route path='payment' element={<DepositPayment />} />
                <Route path='tether' element={<Tether />} />
                <Route path='aed' element={<Aed />} />
                <Route path='withdrawal' element={<Withdrawal />} />
                <Route path='add-bank' element={<Addbank />} />
                <Route path='transaction' element={<Transactionhistory />} />
                <Route path='transaction-detail/:id' element={<TransactionDetail />} />
                <Route path='success' element={<Success />} />
                <Route path='failed' element={<Failed />} />
                <Route path='reciept/:id' element={<Reciept />} />
                {/* <Route path='test-auto' element={<AutoApiCallComponent />} /> */}
                
            </Route>

            <Route element={<Layout />}>
                <Route path='login' element={<Login />} />
                <Route path='register' element={<Register />} />        
                <Route path='forgot-password' element={<ForgotPassword />} />    
                <Route path='otp' element={<Otp />} />        
            </Route>
            
            <Route path='/' element={<Home />} />
            <Route path='*' element={<Navigate to='/' replace />} />
            <Route path='completed' element={<Completed />} />
        </Routes>
    )
}
